// This file was auto-generated by Fern from our API Definition.
const ProtobufMethodTypeValues = {
    Unary: "UNARY",
    ClientStream: "CLIENT_STREAM",
    ServerStream: "SERVER_STREAM",
    BidirectionalStream: "BIDIRECTIONAL_STREAM",
};
export const ProtobufMethodType = Object.assign(Object.assign({}, ProtobufMethodTypeValues), { _visit: (value, visitor) => {
        switch (value) {
            case ProtobufMethodType.Unary:
                return visitor.unary();
            case ProtobufMethodType.ClientStream:
                return visitor.clientStream();
            case ProtobufMethodType.ServerStream:
                return visitor.serverStream();
            case ProtobufMethodType.BidirectionalStream:
                return visitor.bidirectionalStream();
            default:
                return visitor._other();
        }
    } });
